export default {"src":"/_next/static/media/arn.70b1354f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};